/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createStoredValueBalance} from '../api'

export const useMutationCreateStoredValueBalance = createReactQueryMutationHook('createStoredValueBalance', createStoredValueBalance)
